import React, {useCallback, useEffect, useState} from "react"
import {useAuth} from "../../contexts/auth";
import AccessDenied from "../../components/access-denied/access-denied";
import {verifyAccess} from "../../utils/admin.utils";
import './analiz-price.scss'
import {
    getLastDayOfMounthAndHours235959WithoutUTC,
    getFirstDayOfMounthAndHours000000WithoutUTC,
} from "../../utils/date.utils";
import {faChartLine as chart} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import SelectDogovor from "../../components/select-dogovor/select-dogovor";
import {CheckBox} from "devextreme-react";
import ZagolovokFromMenu from "../../components/zagolovok/zagolovok";
import {getReferer} from "../../api/grafana";
import {
    getDefaultAnalizPricePeriod,
} from "./analiz-price-period";
import {AnalizPricePeriodRange} from "./analiz-price-period-range";

const AnalizPrice = () => {

    const {selectedDog} = useAuth()
    const [period, setPeriod] = useState(getDefaultAnalizPricePeriod)
    const [visiblePage, setVisiblePage] = useState(true)
    const [checkBoxValue, setCheckBoxValue] = useState(false);
    const [url, setUrl] = useState()

    useEffect(() => {
        const pageRoles = [6]
        if (!verifyAccess(pageRoles, selectedDog)) {
            setVisiblePage(false)
        } else {
            setVisiblePage(true)
        }
    }, [selectedDog])

    useEffect(() => {

        // не перерисовывем если нет обоих переиодов
        if (!period.start || !period.end) {
            return
        }

        // Перерисовка графаны
        const controller = new AbortController()
        ;(async function () {
            const SERVER_TIME_ZONE = 180 * 60000 // в милисекундах (+3 Москва)
            const LOCAL_TIME_ZONE = new Date().getTimezoneOffset() * 60000 // в милисекундах (Браузер>) Для МСК -180 * 60000
            let refUrl = `/grafana/d/bdzrgqtw42fpca/tarifnoe-menju?var-contract=${selectedDog?.kodDog}&from=${
                (period.start.getTime() - LOCAL_TIME_ZONE) - SERVER_TIME_ZONE
            }&to=${
                (period.end.getTime() - LOCAL_TIME_ZONE) - SERVER_TIME_ZONE
            }&kiosk`
            let res = await getReferer(selectedDog?.kodDog, controller.signal);
            if (res.isOk && res.data) {
                //let ref = res.data
                //refUrl = ref?.replaceAll(/(https?:.*?Moscow)(.*)/gs, `${refUrl}&orgId=1$2`)
                refUrl += res.data;
            }
            setUrl(refUrl);
            //console.log(refUrl)
        })().catch((err) => {
            if (err?.name !== 'AbortError') {
                console.error(err)
            }
        })

        return () => {
            controller.abort()
        }
    }, [period, selectedDog?.kodDog])

    useEffect(() => {
        if (!checkBoxValue || !period.start || !period.end) {
            return
        }
        const start = getFirstDayOfMounthAndHours000000WithoutUTC(period.start)
        const end = getLastDayOfMounthAndHours235959WithoutUTC(period.end)
        if (start.getTime() === period.start.getTime() && end.getTime() === period.end.getTime()) {
            return
        }
        setPeriod({ start, end })
    }, [checkBoxValue, period])

    const onCurrentValueChange = useCallback(({ value }) => {
        const startValue = value?.[0]
        const endValue = value?.[1]

        // Сбрасываем периоды если нет значений (жмакнули крестик)
        if (!startValue && !endValue) {
            setPeriod({ start: null, end: null })
            return
        }
        // Ничего не делаем, если выбрана только одна дата
        if (!startValue || !endValue) {
            return
        }

        // Выбраны обе даты, добавляем время и применяем
        const start = new Date(startValue)
        const end = new Date(endValue)
        start.setHours(0, 0, 0, 0)
        // нормализуем конечную дату
        const endDate = checkBoxValue
        // последний день и 23:59:59 если выбрано по месяцам
        ? getLastDayOfMounthAndHours235959WithoutUTC(end)
        // только время если обычный режим
        : (end.setHours(23, 59, 59, 0), end)
        
        setPeriod({ start, end: endDate })
    }, [checkBoxValue])

    return (
            <div className={'content-block dx-card responsive-paddings analiz-price'}>
                <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={chart} />
                <h3><strong><ZagolovokFromMenu/></strong></h3>
                    <>
                        <div className="row mb-4 big-input" style={{alignItems: 'center'}} >
                            <div className={visiblePage ? "col-xl-6 col-lg-4 col-md-6 col-sm-6 col-xs-12" : "col-12"}>
                                <SelectDogovor all_visible={'false'} visible={true}/>
                            </div>
                            {visiblePage &&
                                <>
                                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-xs-12 mt20xs mt20lg">
                                        <AnalizPricePeriodRange
                                            period1={period.start}
                                            period2={period.end}
                                            byMonths={checkBoxValue}
                                            onValueChanged={onCurrentValueChange}
                                        />
                                        {/*<DateBox
                                            openOnFieldClick={true}
                                            label={'Период начала:'}
                                            labelMode={'floating'}
                                            displayFormat='dd.MM.yyyy'
                                            useMaskBehavior={true}
                                            defaultValue={period1}
                                            value={period1}
                                            max={period2}
                                            onValueChanged={(e) => setPeriod1(new Date(e.value.setHours(0,0,0,0)))}
                                        />
                                    </div>
                                    <div className="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-xs-12 mt20xs mt20lg">
                                        <DateBox
                                            openOnFieldClick={true}
                                            displayFormat='dd.MM.yyyy'
                                            useMaskBehavior={true}
                                            label={'Период окончания:'}
                                            labelMode={'floating'}
                                            defaultValue={period2}
                                            value={period2}
                                            min={period1}
                                            onValueChanged={(e) => setPeriod2(new Date(e.value.setHours(23,59,59,0)))}
                                        />*/}
                                    </div>

                                    <div className="col-lg-2 col-md-6 col-sm-6 col-xs-12 mt20md mt20lg">
                                        <CheckBox
                                            value={checkBoxValue}
                                            onValueChanged={(e) => {
                                                setCheckBoxValue(e.value)
                                            }}
                                            text="По месяцам"
                                        />
                            </div>
                                </>
                            }
                        </div>
                        {visiblePage ?
                            <>
                                {/*{url}*/}
                                <iframe id="grafanaIframe" title={'grafana'}
                                        src={url}
                                        className={'iframe-grafana'}>
                                </iframe>
                            </>
                            :
                            <AccessDenied/>
                        }
                    </>
            </div>
    )
}

export default AnalizPrice
